<script>
import baseList from "@/views/components/base/baseList.vue";

import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "accountList",
        key: "reverb_id",
        url: {
          list: "accountList",
        },
        output: false,
      },
      data: {},
      menus: [
        {
          label: "修改记录",
          name: "account_list",
          auth: "/admin/user/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {
        uid: this.$route?.query?.kv,
        account_type: 1,
      },

      currentRow: null,
      filters: [
        { label: "用户名", name: "user_name", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "用户名",
          key: "user_name",
          width: 200,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.user_name;
            let src = row.user_head;
            let uid = row.user?.uid;
            return h(
              "div",
              {
                style: {
                  height: "34px",
                  lineHeight: "34px",
                  overflow: "hidden",
                },
              },
              [
                h("Avatar", {
                  props: {
                    src: src,
                  },
                  attrs: {
                    title: "UID: " + uid,
                  },
                  style: {},
                }),
                h(
                  "span",
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: "5px",
                      width: "auto",
                      height: "34px",
                      overflow: "hidden",
                    },
                  },
                  uname
                ),
              ]
            );
          },
        },
        {
          title: "修改数量",
          minWidth: 120,
          key: "number",
          render: (h, { row }) => {
            if (row.number < 0) {
              return <span style={{ color: "red" }}>{row.number}</span>;
            } else if (row.number > 0) {
              return <span style={{ color: "green" }}>{row.number}</span>;
            } else {
              return <span>{row.number}</span>;
            }
          },
        },
        {
          title: "操作来源",
          minWidth: 120,
          key: "from_type_name",
        },
        {
          title: "操作时间",
          minWidth: 120,
          key: "create_time",
        },
        {
          title: "备注",
          minWidth: 120,
          key: "text",
        },
      ],
    };
  },
  created() {},

  methods: {},
};
</script>
